module.exports = __webpack_public_path__ + "front/img/u9.46d72eb1.jpg";